<template>
  <span class="capped-value__wrapper" :class="{ 'flex-column': isCapped }">
    <span :class="{ 'capped-max': isCapped }" class="capped-value__span">
      <span v-if="isAmountType">$</span>
      {{ computedValue }}
    </span>
    <span v-if="validCap" class="capped-value capped-value__span">
      / <span v-if="isAmountType">$</span>
      {{ cap }}
    </span>
  </span>
</template>

<script>
import currencyFormatter from '@/core/filters/formatCurrency';

export default {
  name: 'CappedValueDisplay',
  props: {
    value: {
      type: Number,
      required: true,
    },
    cap: {
      type: Number,
      required: true,
    },
    isAmountType: {
      type: Boolean,
      required: true,
    },
    column: {
      type: String,
      required: true,
    },
  },
  computed: {
    validCap() {
      return this.cap > -1;
    },
    isCapped() {
      return this.value >= this.cap && this.validCap;
    },
    computedValue() {
      return !Number.isInteger(this.value) ? currencyFormatter(this.value, 'en-US').replace('$', '') : this.value;
    }
  }
};
</script>

<style lang="scss">
.capped-value__wrapper {
  display: flex;
  flex-direction: row;
}
.capped-value__span {
  display: flex;
  justify-content: center;
}
</style>